export function isResponsiveView() : boolean {
  const mql = window.matchMedia("all and (max-width: 992px)")
  return mql.matches;
}
